module.exports = __webpack_public_path__ + "static/media/user-logo.552d6d1e.svg";